import Vue from 'vue'
import VueRouter from 'vue-router'

import { zirafHTTP, bus } from './main'
import store from './store'

import Start from '@/views/Start.vue'
const EntityData = () => import('@/views/EntityData.vue')
const Question = () => import('@/views/Question.vue')
const Thanks = () => import('@/views/Thanks.vue')
const PageNotFound = () => import('@/views/PageNotFound.vue')

Vue.use(VueRouter)

const routes = [
	{
		path: '/start/:id',
		name: 'start',
		component: Start,
		meta: {
			bottomText: 'Ziraf',
			image: 'computer.png',
			title: 'Start'
		}
	},
	{
		path: '/gegevens',
		name: 'entityData',
		component: EntityData,
		meta: {
			protected: true,
			bottomText: 'Ziraf',
			title: 'Gegevens'
		}
	},
	{
		path: '/vraag/:questionId/:title',
		name: 'question',
		component: Question,
		meta: {
			protected: true
		}

	},
	{
		path: '/bedankt',
		name: 'thanks',
		component: Thanks,
		meta: {
			protected: true,
			title: 'Bedankt!'
		}

	},
	{
		path: '/pagina-niet-gevonden',
		alias: '*',
		name: 'pageNotFound',
		component: PageNotFound,
		meta: {
			title: 'Oeps!'
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}

	bus.$emit('toggleLogo', true)
	bus.$emit('togglePrivacy', false)

	if (from.name === 'thanks') {
		bus.$emit('setQuestionNextButton', true)
	} else if(from.name === 'question' && to.name === 'question' && JSON.parse(from.params.questionId) > JSON.parse(to.params.questionId)) {
		bus.$emit('setQuestionNextButton', true)
	} else {
		bus.$emit('setQuestionNextButton', false)
	}

	if (to.meta.title) {
		document.title = `${process.env.VUE_APP_TITLE} | ${to.meta.title}`
	} else if (to.name === 'question') {
		document.title = `${process.env.VUE_APP_TITLE} | Vraag ${to.params.questionId}`
	} else {
		document.title = process.env.VUE_APP_TITLE
	}

	let routToNavigateTo: any = undefined

	if (to.meta.protected) {
		if (to.name === 'question' || to.name === 'thanks') {
			if (store.getters.entity && store.getters.privacyStatementSelected) {
				if (from.name === 'question') {
					if (!(to.name === 'question' && JSON.parse(to.params.questionId) < JSON.parse(from.params.questionId))) {
						const answers = store.getters.entityTestValues
						const questions = store.getters.questions
						const questionIndex = (JSON.parse(from.params.questionId) - 1)
						let safeToContinue = true
	
						switch(questions[questionIndex].type) {
							case 'versus':
								let allOptionsSelected = true
				
								;[...answers[questionIndex]].forEach((option: string | null) => {
									if (!option) allOptionsSelected = false
								})
				
								if (!allOptionsSelected) safeToContinue = false				
								break
							case 'image-comparison':
								if (!answers[questionIndex] || answers[questionIndex].length !== questions[questionIndex].choices.length) safeToContinue = false
								break
							case 'panels':
							case 'word-cloud':
								if (!answers[questionIndex] || !answers[questionIndex].length) safeToContinue = false
								break
							case 'word-cloud-multiple':
								;[...answers[questionIndex]].forEach((cloud: string[]) => {
									if (cloud.length < 1) safeToContinue = false
								})
								break
							case 'terms':
								if (!answers[questionIndex]) safeToContinue = false
								if (!answers[questionIndex].salary) safeToContinue = false
								if (!answers[questionIndex].salary.min || answers[questionIndex].salary.min < 0) safeToContinue = false
								if (!answers[questionIndex].salary.max || answers[questionIndex].salary.min > answers[questionIndex].salary.max) safeToContinue = false
								if (!answers[questionIndex].hours) safeToContinue = false
								if (!answers[questionIndex].hours.min || answers[questionIndex].hours.min < 0) safeToContinue = false
								if (!answers[questionIndex].hours.max || answers[questionIndex].hours.min > answers[questionIndex].hours.max) safeToContinue = false
								if (!answers[questionIndex].car) safeToContinue = false
								break
							case 'feedback':
								break
							default:
								safeToContinue = false
						}
	
						if (!safeToContinue) {
							routToNavigateTo = from
						}
					}
				}
			} else {
				routToNavigateTo = from
			}
		} else {
			if (!store.getters.entity) {
				routToNavigateTo = { name: 'pageNotFound' }
			}
		}
	}

	if (!routToNavigateTo) {
		if (to.name === 'start' && !store.getters.entity) {
			zirafHTTP.get(`test/${to.params.id}`)
				.then(response => {
					store.dispatch('setEntity', response.data)
				})
				.catch(error => {
					router.replace({ name: 'pageNotFound' })
				})
		}

		if (to.meta.bottomText || to.meta.bottomText === '') {
			bus.$emit('setBottomText', to.meta.bottomText)
		} else if (to.name === 'question') {
			function questionId(): string {
				if ((JSON.parse(to.params.questionId)) > 9) {
					return JSON.parse(to.params.questionId)
				} else {
					return `0${to.params.questionId}`
				}
			}

			bus.$emit('setBottomText', questionId())
		} else {
			bus.$emit('setBottomText', '')
		}

		bus.$emit('setImage', false)
		
		if (to.meta.image) {		
			setTimeout(() => {
				bus.$emit('setImage', to.meta.image)
			}, 200)
		}
	}

	bus.$emit('scrollToTop')

	next(routToNavigateTo)
})

export default router
